
export const TYPE_TEACHER = 2;
export const TYPE_STUDENT = 1;

export const USER_TYPES = [
  { value: TYPE_TEACHER, text: 'Teacher' },
  { value: TYPE_STUDENT, text: 'Student' },
];
